import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3976b6bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 ant-col-xxl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA:")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_27 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_30 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_31 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_32 = {
  key: 3,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_35 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-card ss-card-space ss-alinhar-texto-esquerda tabela-container" }
const _hoisted_38 = {
  key: 0,
  class: "ss-coluna-custom-header"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_relatorio_painel_vendas = _resolveComponent("selecionar-tipo-relatorio-painel-vendas")!
  const _component_selecionar_agrupador_relatorio = _resolveComponent("selecionar-agrupador-relatorio")!
  const _component_selecionar_campos_relatorio_vendas = _resolveComponent("selecionar-campos-relatorio-vendas")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_selecionar_relatorio_painel_vendas = _resolveComponent("selecionar-relatorio-painel-vendas")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_cliente = _resolveComponent("selecionar-cliente")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: 'VENDAS',
          tituloRecurso: _ctx.state.tituloRecurso,
          exibirAtalhosTela: false,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.dadosEmpresa.codigoEmpresa]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Imprimir",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                }, [
                  _createVNode(_component_icone, { nome: "imprimir" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Word",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                }, [
                  _createVNode(_component_icone, { nome: "word" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Excel",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                }, [
                  _createVNode(_component_icone, { nome: "excel" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar CSV",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                }, [
                  _createVNode(_component_icone, { nome: "download-arquivo" })
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.buscarRelatorio && _ctx.buscarRelatorio(...args)))
                }, _hoisted_7)
              ])
            ])
          ]),
          _: 1
        }, 8, ["tituloRecurso", "empresasSelecionadas"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_collapse, {
          ghost: "",
          class: "ss-accordion",
          activeKey: _ctx.state.mostrarConfiguracao,
          "onUpdate:activeKey": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.mostrarConfiguracao) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "Configuração do Relatório"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_a_select, {
                          value: _ctx.dadosEmpresa.codigoEmpresa,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dadosEmpresa.codigoEmpresa) = $event)),
                          options: _ctx.telaBase.empresasDisponiveis,
                          style: {"width":"100%"},
                          optionFilterProp: "label",
                          onChange: _ctx.atualizarSelecaoEmpresas,
                          disabled: true
                        }, null, 8, ["value", "options", "onChange"])
                      ])
                    ]),
                    _createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_a_form_item, {
                              label: "Descrição do Relatório",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.dadosRelatorio.descricao) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.dadosRelatorio.descricao]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo do Relatório",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_relatorio_painel_vendas, {
                                  valor: _ctx.state.dadosRelatorio.tipoRelatorio,
                                  "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.dadosRelatorio.tipoRelatorio) = $event)),
                                  disabled: false,
                                  "radio-button": false
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: "Agrupador Por",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_agrupador_relatorio, {
                                  valor: _ctx.state.dadosRelatorio.agrupador,
                                  "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dadosRelatorio.agrupador) = $event)),
                                  disabled: false,
                                  "radio-button": false
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_selecionar_campos_relatorio_vendas, {
                              campos: _ctx.state.dadosRelatorioCampos,
                              "onUpdate:campos": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.dadosRelatorioCampos) = $event))
                            }, null, 8, ["campos"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_a_button, {
                              class: "ant-btn ant-btn-primary ss-btn-tela",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.salvar()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Salvar Filtros")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_a_collapse, {
          ghost: "",
          class: "ss-accordion",
          activeKey: _ctx.state.mostrarFiltros,
          "onUpdate:activeKey": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.mostrarFiltros) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "Filtros do Relatório"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_a_form_item, {
                              label: "Relatório",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_relatorio_painel_vendas, {
                                  codigoSelecionado: _ctx.state.codigoRelatorio,
                                  "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.codigoRelatorio) = $event)),
                                  descricaoSelecionado: _ctx.state.nomeRelatorio,
                                  "onUpdate:descricaoSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.nomeRelatorio) = $event)),
                                  empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                                  disabled: false,
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.obterDadosRelatorio()))
                                }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo do Relatório",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_relatorio_painel_vendas, {
                                  valor: _ctx.state.tipoRelatorio,
                                  "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.tipoRelatorio) = $event)),
                                  disabled: false,
                                  "radio-button": false
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_a_form_item, {
                              label: "Agrupador Por",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_agrupador_relatorio, {
                                  valor: _ctx.state.tipoAgrupador,
                                  "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.tipoAgrupador) = $event)),
                                  disabled: false,
                                  "radio-button": false
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_a_form_item, {
                              label: "Período",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                                  valor: _ctx.state.periodo,
                                  "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.periodo) = $event)),
                                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.periodoAlterado()))
                                }, null, 8, ["valor"]),
                                (_ctx.state.periodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Data Inicial e Final",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_selecionar_data_inicial_final, {
                                              dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                              "onUpdate:dataInicialSelecionada": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                              dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                              "onUpdate:dataFinalSelecionada": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event)),
                                              onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.buscarRelatorio()))
                                            }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (_ctx.state.tipoRelatorio === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(_component_a_form_item, {
                                  label: "Tipo de Operação",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_tipo_operacao, {
                                      varios: true,
                                      codigosSelecionados: _ctx.state.tipoOperacao,
                                      "onUpdate:codigosSelecionados": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.tipoOperacao) = $event)),
                                      disabled: false,
                                      empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                    }, null, 8, ["codigosSelecionados", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.tipoRelatorio === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vendedor",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_colaborador, {
                                      varios: true,
                                      codigosSelecionados: _ctx.state.vendedores,
                                      "onUpdate:codigosSelecionados": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.vendedores) = $event)),
                                      disabled: false,
                                      empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                    }, null, 8, ["codigosSelecionados", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.tipoRelatorio === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_a_form_item, {
                                  label: "Cliente",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_cliente, {
                                      varios: true,
                                      codigosSelecionados: _ctx.state.clientes,
                                      "onUpdate:codigosSelecionados": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.clientes) = $event)),
                                      disabled: false,
                                      empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                    }, null, 8, ["codigosSelecionados", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.tipoRelatorio === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_component_a_form_item, {
                                  label: "Produto",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_produto, {
                                      varios: true,
                                      codigosSelecionados: _ctx.state.produtos,
                                      "onUpdate:codigosSelecionados": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.produtos) = $event)),
                                      disabled: false,
                                      empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                    }, null, 8, ["codigosSelecionados", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_selecionar_campos_relatorio_vendas, {
                              campos: _ctx.state.camposRelatorio,
                              "onUpdate:campos": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.camposRelatorio) = $event))
                            }, null, 8, ["campos"])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_a_button, {
                              class: "ant-btn ant-btn-primary ss-btn-tela",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.salvar()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Salvar")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_card, { class: "tabela-wrapper" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.state.colunas.filter(item => item.visible),
              "data-source": _ctx.state.dados.itens,
              rowKey: "id",
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.state.telaMobile ? null : { x: 'max-content', y: _ctx.defineAlturaScrollDinamica(450) },
              size: "small"
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.ordering)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(column.title), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(column.title), 1))
              ]),
              bodyCell: _withCtx(({ column, text }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararPorcentagem)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2) + "%"), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(text), 1))
              ]),
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  resultadoPesquisa: !_ctx.telaBase.carregando,
                  mensagem: _ctx.telaBase.carregando
              ? 'Buscando informações, por favor aguarde...'
              : 'Nenhum registro foi encontrado com estes filtros!'
                }, null, 8, ["resultadoPesquisa", "mensagem"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivoPdf
      }, null, 8, ["arquivos"])
    ])
  ]))
}